import {ApiHelper} from "../apiHelper";
import {BaseDao} from "./BaseDao";
import {ConstantMan} from "../constantMan";
import { Observable } from 'rxjs';
import { Brand } from '../../models/brand';
import {BuySchedule} from "../../models/buySchedule";
import {BuyScheduleChangeRequest} from "../../models/buyScheduleChangeRequest";
import {HttpHeaders} from "@angular/common/http";

export class BuyScheduleDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.BUY_SCHEDULES, apiHelper);
  }

  public filterScheduleResults(reqBody: ScheduleFilterRequest): Observable<any> {
    const url = this.apiHelper.getServiceName() + this.getResource() + '/filter-schedule';
    const headers = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall(
      url,
      'POST',
      null,
      reqBody,
      headers
    );
  }

  public createMany(buySchedules: BuySchedule[], publicId?: string): Observable<BuySchedule[]> {
    const url = this.apiHelper.getServiceName() + this.getResource() + '/bulk';
    let headers: HttpHeaders;
    if (publicId) {
      headers = this.apiHelper.getChangeManagementPublicHeaders(publicId);
    } else {
      headers = this.apiHelper.getDefaultHeader();
    }
    return this.apiHelper.apiCall(
        url,
        'POST',
        null,
        buySchedules,
        headers
    );
  }

  public updateMany(updates: { id: string; update: Object }[], publicId?: string): Observable<BuySchedule[]> {
    const url = this.apiHelper.getServiceName() + this.getResource() + '/update/bulk';
    let headers: HttpHeaders;
    if (publicId) {
      headers = this.apiHelper.getChangeManagementPublicHeaders(publicId);
    } else {
      headers = this.apiHelper.getDefaultHeader();
    }
    return this.apiHelper.apiCall(
        url,
        'PUT',
        null,
        updates,
        headers
    );
  }

  public find(search: Object): Observable<BuySchedule[]> {
    const url = this.apiHelper.getServiceName() + this.getResource() + '/find';
    const headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, search, headers);
  }

  formatTime (time) {
    let [hours, minutes, seconds] = time.split(':');
    hours = parseInt(hours, 10);
    let suffix = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    if(time.includes('AM') || time.includes('PM')) {
      suffix = '';
    }
    return hours + ":" + minutes + suffix;
  }

  formatDay (day) {
    switch (day) {
      case "Monday":
        return "M";
      case "Tuesday" :
        return "Tu";
      case "Wednesday":
        return "Wed";
      case "Thursday":
        return "Th";
      case "Friday":
        return "F";
      case "Saturday":
        return "Sat";
      case "Sunday":
        return "Sun";
    }
  }

  formatSingleDate (startDate) {
    startDate = startDate.split('T')[0];
    let startDateParts = startDate.split('-');
    startDate = startDateParts[1] + "/" + startDateParts[2] + "/" + startDateParts[0];

    return startDate;
  }
}

export interface ScheduleFilterRequest {
  brand: string,
  length: number,
  station: string,
  daypart: string,
  startDate: Date,
  endDate: Date
}
